import React from 'react'
import Report from "../Report/Report";

export default props => {

  return (

    <React.Fragment>

      <main className="params">

        <h1 className="params__title">
          {props.title}
        </h1>

        <div className="params-content">

          <div className="params-content-descr error">
            {props.error}
          </div>

        </div>

      </main>

      <Report/>

    </React.Fragment>

  )

}